import { useEffect, useState } from 'react'

interface Props { onUnlock: () => void }

export default function LockScreen({ onUnlock }: Props) {
  const [time, setTime] = useState(new Date())

  useEffect(() => {
    const id = setInterval(() => setTime(new Date()), 1000)
    return () => clearInterval(id)
  }, [])

  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      if (e.key === 'Escape' || e.key === ' ') { e.preventDefault(); onUnlock() }
    }
    window.addEventListener('keydown', handler)
    return () => window.removeEventListener('keydown', handler)
  }, [onUnlock])

  const hours = time.getHours().toString().padStart(2, '0')
  const minutes = time.getMinutes().toString().padStart(2, '0')
  const dateStr = time.toLocaleDateString(undefined, { weekday: 'long', month: 'long', day: 'numeric' })

  return (
    <div onClick={onUnlock} style={{
      position: 'fixed', inset: 0, zIndex: 999999,
      background: 'rgba(0,0,0,0.85)', backdropFilter: 'blur(40px)',
      display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
      cursor: 'pointer', userSelect: 'none',
    }}>
      <div style={{ fontSize: '120px', fontWeight: 200, color: '#fff', letterSpacing: '-4px', lineHeight: 1 }}>
        {hours}:{minutes}
      </div>
      <div style={{ fontSize: '20px', color: 'rgba(255,255,255,0.7)', marginTop: '12px', fontWeight: 400 }}>
        {dateStr}
      </div>
      <div style={{ fontSize: '13px', color: 'rgba(255,255,255,0.4)', marginTop: '40px' }}>
        Click or press Space to unlock
      </div>
    </div>
  )
}
